<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_v"><em class="italic">To Annika—with all my love</em></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?70981689